import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ahaui/ahaui/apps/docs/src/layouts/ApiLayout.js";
import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import formMessage from 'src/examples/Message/default';
import systemMessage from 'src/examples/Message/system';
import variantFormMessage from 'src/examples/Message/variantForm';
import variantSystemMessage from 'src/examples/Message/variantSystem';
import layoutMessage from 'src/examples/Message/layout';
import layout2Message from 'src/examples/Message/layout-2';
import layout3Message from 'src/examples/Message/layout-3';
import layout4Message from 'src/examples/Message/layout-4';
import layout5Message from 'src/examples/Message/layout-5';
export const query = graphql`
  query MessageMDXQuery {
    metadata: componentMetadata(displayName: { eq: "Message" }) {
      ...ComponentApi_metadata
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "message"
    }}>{`Message`}</h1>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Using messages to communicate between system and users, to notify or to show the system's responses to user’s actions.`}</p>
    <img src={require('src/assets/structure/stb_message-structure.jpg')} srcSet={`${require('src/assets/structure/stb_message-structure@2x.jpg')} 2x`} alt="Message structure" />
    <ol className="u-textGray u-marginTopTiny">
  <li>
        Heading
    <i className="u-text200"> -  Like a message title, using heading for message overview purpose.</i>
  </li>
  <li>
        Message
    <i className="u-text200"> -  The information that the system wants to send to users. Message content can include paragraphs and links.</i>
  </li>
  <li>
        Close button
    <i className="u-text200"> - Optional to close the message immediately.</i>
  </li>
  <li>
        CTA button
    <i className="u-text200"> -  Designed for system messages only. CTA button is the main action that users can interact with a system message.</i>
  </li>
  <li>
        Background
    <i className="u-text200"> - The message background attribute specifies the message variants by color changing.</i>
  </li>
    </ol>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <h3 {...{
      "id": "types"
    }}>{`Types`}</h3>
    <h4 {...{
      "id": "form-messages"
    }}>{`Form messages`}</h4>
    <p>{`Form messages are alerts that provide contextual feedback messages for user actions with input forms. It's available for any length of text, as well as an optional dismiss button.`}</p>
    <CodeView codeText={formMessage} mdxType="CodeView" />
    <h4 {...{
      "id": "system-messages"
    }}>{`System messages`}</h4>
    <p>{`System messages provide contextual feedback messages for typical user actions with the handful of available and flexible alert messages. It's available for any length of text, a CTA button, as well as an optional dismiss button.`}</p>
    <CodeView codeText={systemMessage} mdxType="CodeView" />
    <h3 {...{
      "id": "variants"
    }}>{`Variants`}</h3>
    <h4 {...{
      "id": "form-messages-1"
    }}>{`Form messages`}</h4>
    <CodeView exampleClassName="example-messages" codeText={variantFormMessage} mdxType="CodeView" />
    <h4 {...{
      "id": "system-messages-1"
    }}>{`System messages`}</h4>
    <CodeView exampleClassName="example-messages" codeText={variantSystemMessage} mdxType="CodeView" />
    <h3 {...{
      "id": "layout"
    }}>{`Layout`}</h3>
    <CodeView codeText={layoutMessage} mdxType="CodeView" />
    <CodeView codeText={layout2Message} mdxType="CodeView" />
    <CodeView codeText={layout3Message} mdxType="CodeView" />
    <CodeView codeText={layout4Message} mdxType="CodeView" />
    <CodeView codeText={layout5Message} mdxType="CodeView" />
    <h2 {...{
      "id": "design-reference"
    }}>{`Design Reference`}</h2>
    <p>{`N/A`}</p>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ComponentApi metadata={props.data.metadata} mdxType="ComponentApi" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      